import { slice } from '../slices/teamShare';

const nameSpace = slice.name;

export const isLoading = (state: RootState) => state[nameSpace].isLoading;
export const totalCount = (state: RootState) => state[nameSpace].totalCount;
export const page = (state: RootState) => state[nameSpace].page;
export const userList = (state: RootState) => state[nameSpace].userList;
export const autocompleteUserList = (state: RootState) => state[nameSpace].autocompleteUserList;
export const autocompleteSelectedUserList = (state: RootState) => state[nameSpace].autocompleteSelectedUserList;
